module.exports = __webpack_public_path__ + "img/jamaicans.cabcb0b7.svg";